/**
 * Parse API / DB money values for display math (handles commas, spaces, string decimals).
 */
export function parseMoneyAmount(value: unknown): number {
  if (value == null) {
    return 0
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  const s = String(value).trim()
  if (s === '') {
    return 0
  }
  const normalized = s.replace(/,/g, '').replace(/[^\d.]/g, '')
  if (normalized === '' || normalized === '.') {
    return 0
  }
  const n = parseFloat(normalized)
  return Number.isFinite(n) ? n : 0
}
